var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1665 3.33337V8.33337H14.1665",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0751 12.5C16.5334 14.0332 15.508 15.3489 14.1535 16.2487C12.799 17.1485 11.1888 17.5838 9.56541 17.4888C7.94205 17.3938 6.39352 16.7738 5.15319 15.7222C3.91286 14.6706 3.04792 13.2443 2.6887 11.6584C2.32949 10.0724 2.49546 8.41263 3.16161 6.92919C3.82777 5.44576 4.95801 4.21902 6.38202 3.43384C7.80604 2.64865 9.44667 2.34755 11.0567 2.57592C12.6667 2.80429 14.1589 3.54975 15.3084 4.69997L19.1667 8.3333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.084654b0109babd01b037f8da303e73c.svg";
export { ForwardRef as ReactComponent };